<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-lg-3 col-md-6 position-relative">
                        <div class="d-flex align-items-center position-absolute btm-0">
                            <div>
                                <h3 class="font-medium">
                                    {{contract.contract_number}}
                                </h3>
                                <span>Contract No</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 position-relative">
                        <div class="d-flex align-items-center position-absolute btm-0">
                            <div>
                                <h3 class="font-medium m-b-0">{{contract.owner.biz_name}}</h3>
                                <span v-if="contract.type === 'SALE'">Seller</span>
                                <span v-if="contract.type === 'PURCHASE'">Buyer</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 position-relative">
                        <div class="ml-auto position-absolute btm-0">
                            <div>
                                <h3 class="font-medium m-b-0">{{contract.counterparty.biz_name}}</h3>
                                <span class="text-right" v-if="contract.type === 'PURCHASE'">Seller</span>
                                <span class="text-right" v-if="contract.type === 'SALE'">Buyer</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-1 col-md-6 position-relative">
                        <div class="d-flex align-items-center position-absolute btm-0">
                            <div>
                                <h3>
                                    <span class="label label-cyan" v-if="contract.status === 'DRAFT'">Draft</span>
                                    <span class="label label-indigo"
                                          v-if="contract.status === 'POSTED'">Posted</span>
                                    <span class="label label-dark-green" v-if="contract.status === 'CONFIRMED'">Confirmed</span>
                                    <span class="label label-grey" v-if="contract.status === 'VOID'">Void</span>
                                </h3>
                                <span>Status</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6 position-relative text-right">
                        <div class="ml-auto  btm-0">
                            <div>
                                <h3 class="font-medium text-right m-b-0">
                                    <i class="fas fa-credit-card text-primary" v-if="contract.type === 'SALE'"/>
                                    <i class="fas fa-cart-arrow-down text-cyan" v-else/>
                                    {{contract.type || '-' | capitalize}}
                                </h3>
                                <span class="text-right">Contract Type</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row m-t-25">
            <div class="col-md-8">
                <contract-overview :contract="contract" v-if="contract.type"></contract-overview>
                <contract-items :contract="contract"></contract-items>
                <payment-terms :contractTotal="contract.total" :contractType="contract.type" :contractid="contractid"
                               :status="contract.status"></payment-terms>
                <contract-document :contractid="contractid" :status="contract.status"></contract-document>
            </div>
            <div class="col-md-4">
                <sidebar :contract="contract"></sidebar>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import ContractOverview from "./ContractOverview";
    import PaymentTerms from "./PaymentTerms";
    import ContractDocument from "./ContractDocuments";
    import Sidebar from "./sidebar/Sidebar";
    import ContractItems from "./ContractItems";

    export default {
        name: "ViewContract",
        components: {ContractItems, Sidebar, ContractDocument, PaymentTerms, ContractOverview},
        props: ["contractid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                contract: {
                    type: null,
                    goods_services_specs: [{
                        key: null,
                        value: null
                    }],
                    contract_props: null,
                    attachments: [],
                    expires_at: null,
                    created_at: null,
                    owner: {
                        biz_name: ''
                    },
                    counterparty: {
                        biz_name: ''
                    },
                    goods_services: [],
                    quantity: null,
                    total: null,
                    pricing_terms: {
                        rate: null,
                        method: ''
                    },
                    payment_terms: []
                }
            }
        },
        beforeMount() {
            this.init();
            this.$root.$on('refreshContract', () => {
                this.init();
            })
        },
        methods: {
            async init() {
                await this.getContract();
            },
            async getContract() {
                $(".preloader").fadeIn();
                let reply = await this.$http.get(`/express/${this.currentOrg.express_id}/contracts/${this.contractid}`);
                $(".preloader").fadeOut();
                this.contract = reply.data.contract;
            }
        }
    }
</script>

<style scoped>

</style>
